import { useCallingContext } from "../../../context/CallingContext";
import { CallingFeedback } from "./CallingFeedback";
import { InCalling } from "./InCalling";

const Calling = () => {
  const { isEndCalled } = useCallingContext();
  return (
    <div className="h-[100%] bg-[black]">
      {isEndCalled ? <CallingFeedback /> : <InCalling />}
    </div>
  );
};

export { Calling };
